
(function userDefinition() {
    'use strict';
    angular.module('Entities')
        .service('userService', [
            'restUrlBuilder', 'config', function userService(restUrlBuilder, config) {
                restUrlBuilder = restUrlBuilder('auth');

                // Se usa desde el ver y editar perfil,(cambiar el nombre)
                this.getLoguedUserById = function getById(id, forEdit) {
                    
                    if (angular.isUndefined(forEdit)) {
                        forEdit = true;
                    }

                    return restUrlBuilder.one('users', 'logged')
                                         .get({
                                             params: {
                                                 applicationId: config.appId(),
                                                 forEdit: forEdit
                                             }
                                         });
                };

                this.getById = function getById(id) {
                     var params = { Id: id };

                     return restUrlBuilder.one('users').get({ params: params });
                };


                this.get = function get(nickName, name, lastName, mail, organizationalUnitId, completeName, identifier, page, itemsPerPage, orderby, organizationalUnitChildestId) {
                    var params = { NickName: nickName, FirstName: name, LastName: lastName, Mail: mail, OrganizationalUnitId: organizationalUnitId, FullName: completeName, Identifier: identifier, Page: page, ItemPerPage: itemsPerPage, OrganizationalUnitChildestId: organizationalUnitChildestId };

                    return restUrlBuilder.all('users')
                        .get({ params: params });

                };

                this.getAllForUser = function (name) {
                    var params = { name: name };

                    return restUrlBuilder.all('users/GetAllForUser')
                        .get({ params: params });
                };

                this.setRedirectOption = function (userId, optionId) {
                    return restUrlBuilder.all('users/SetRedirectOption/' + userId + '/' + optionId)
                        .put();
                };
            }
        ]);
})();